var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.3607,
    height: 42.3607,
    transform: "translate(0.63916)",
    fill: "#FF9515"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4 24.8571L26.147 21L19.4 17.1429V24.8571ZM34.428 14.79C34.597 15.3943 34.714 16.2043 34.792 17.2329C34.883 18.2614 34.922 19.1486 34.922 19.92L35 21C35 23.8157 34.792 25.8857 34.428 27.21C34.103 28.3671 33.349 29.1129 32.179 29.4343C31.568 29.6014 30.45 29.7171 28.734 29.7943C27.044 29.8843 25.497 29.9229 24.067 29.9229L22 30C16.553 30 13.16 29.7943 11.821 29.4343C10.651 29.1129 9.897 28.3671 9.572 27.21C9.403 26.6057 9.286 25.7957 9.208 24.7671C9.117 23.7386 9.078 22.8514 9.078 22.08L9 21C9 18.1843 9.208 16.1143 9.572 14.79C9.897 13.6329 10.651 12.8871 11.821 12.5657C12.432 12.3986 13.55 12.2829 15.266 12.2057C16.956 12.1157 18.503 12.0771 19.933 12.0771L22 12C27.447 12 30.84 12.2057 32.179 12.5657C33.349 12.8871 34.103 13.6329 34.428 14.79Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiYoutube);
export default __webpack_public_path__ + "static/media/mdi_youtube.affd6f444c37dc9c0941160d649728a2.svg";
export { ForwardRef as ReactComponent };